import { render, staticRenderFns } from "./InvoiceIcon.vue?vue&type=template&id=2c71dba2&scoped=true&"
import script from "./InvoiceIcon.vue?vue&type=script&lang=js&"
export * from "./InvoiceIcon.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceIcon.vue?vue&type=style&index=0&id=2c71dba2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c71dba2",
  null
  
)

export default component.exports